import React, { useState } from "react";
import { Outlet } from "react-router-dom";
import ChatbotSidebar from "./ChatbotSidebar";

function ChatbotLayout() {
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);

  return (
    <div className="h-screen w-screen flex bg-slate-900 overflow-hidden">

      {/* SIDEBAR */}
      <aside
        className={`
          fixed md:static inset-y-0 left-0 z-40
          w-64 bg-slate-950 border-r border-slate-800
          transform transition-transform duration-300
          ${isSidebarOpen ? "translate-x-0" : "-translate-x-full"}
          md:translate-x-0
        `}
      >
        <ChatbotSidebar onSelect={() => setIsSidebarOpen(false)} />
      </aside>

      {/* OVERLAY */}
      {isSidebarOpen && (
        <div
          className="fixed inset-0 bg-black/50 z-30 md:hidden"
          onClick={() => setIsSidebarOpen(false)}
        />
      )}

      {/* MAIN */}
      <div className="flex-1 flex flex-col h-full overflow-hidden">

        {/* MOBILE HEADER */}
        <header className="h-12 flex items-center px-4 border-b border-slate-800 bg-slate-950 md:hidden">
          <button
            onClick={() => setIsSidebarOpen(true)}
            className="text-slate-300 text-lg"
          >
            ☰
          </button>
          <span className="ml-3 text-sm font-semibold">Chat</span>
        </header>

        {/* ROUTED CONTENT */}
        <main className="flex-1 h-full overflow-hidden">
          <Outlet />
        </main>

      </div>
    </div>
  );
}

export default ChatbotLayout;
